<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#182444"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#182444" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 sm9 md10 text-left>
        <span class="mainHeader">Constituencies</span>
      </v-flex>
      <!-------------------------ADD CUSTOMER TO SCHEME----------------------------->
      <v-flex xs12 sm3 md2 class="buttons1" pt-2 pt-sm-0 text-right>
        <v-btn dark color="#182444" @click="adddialog = true" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add New
        </v-btn>
      </v-flex>
       <!-------------------------LIST OF CUSTOMER IN SCHEME----------------------------->
      <v-flex xs12 py-6 text-left>
        <v-card 
          class="rounded-lg"
          elevation="0"
          :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
          :flat="$route.name == 'Dashboard' ? true : false"
        >
        <v-layout wrap v-if="constituencyList">
          <v-flex xs12 px-2 py-4>
                    <v-layout wrap px-2>
                      <v-flex xs3 class="text-left tablefont"><b>S.No.</b></v-flex>
                      <v-flex xs3 class="text-left tablefont"><b>Constituency</b></v-flex>
                      <v-flex xs3 class="text-left tablefont"><b>Add User</b></v-flex>
                      <v-flex xs3 class="text-left tablefont"><b>Actions</b></v-flex>
                      
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 px-2>
                <v-divider ></v-divider>
            </v-flex>
                <v-flex xs12 v-if="constituencyList.length > 0">
                  <!-- <v-expansion-panels flat>
                    <v-expansion-panel v-for="(value, i) in constituencyList" :key="i" > -->
                      <!-- <v-expansion-panel-header
                        v-if="value._id" class="pa-2"
                      > -->
                        <!-- @click="getinnerData(value._id)" -->
                        <v-layout wrap px-2 pt-2 v-for="(value, i) in constituencyList" :key="i">
                          <v-flex xs3 align-self-center pl-2>
                        <span v-if="page == 1">
                          {{ i + 1 }}
                        </span>
                        <span v-else>
                          {{ i + 1 + 50 * (page - 1) }}
                        </span>
                      </v-flex>
                      <v-flex xs3 align-self-center pl-1>
                        <span  v-if="value.name">{{
                          value.name
                        }}</span>
                        <span v-else>-</span>
                      </v-flex>
                      <v-flex xs3 align-self-center pl-2>
                        <v-icon  color="#182444"  @click="(addUser=true),(addId = value._id)">mdi-account-multiple-plus</v-icon>
                      </v-flex>
                      <v-flex xs3 align-self-center class="text-left" pl-5>
                         <v-layout wrap>
                          <v-flex xs1>
                            <!-- <v-btn dark color="#182444" small @click="$router.push('/addPanchayat?id='+value._id)"> -->
                              <!-- view Panchayat -->
                              <v-icon
                            size="18"
                            title="View Panchayat"
                            style="cursor: pointer"
                            color="#182444"  @click="$router.push('/addPanchayat?id='+value._id)"
                            >mdi-eye</v-icon
                          >
                            <!-- </v-btn> -->
                       </v-flex>
                          <v-flex xs2>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog = true), (DeleteId = value._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs2>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit = true), (editItem = value)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                        </v-flex>
                        <v-flex xs12 pt-2>
                <v-divider ></v-divider>
            </v-flex>
                        </v-layout>
                      <!-- </v-expansion-panel-header> -->
                      <!-- <v-expansion-panel-content>
                        <v-layout wrap v-if="value.usersAddedByMPCandidate">
                          <v-flex xs12 class="title1" v-if="value.usersAddedByMPCandidate.length>0">
                        Users List
                          </v-flex>
                          <v-flex xs12 v-if="value.usersAddedByMPCandidate.length>0">
                       <v-simple-table v-if="value.usersAddedByMPCandidate">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">No.</th>
                                <th class="text-left">Name</th>
                                <th class="text-left">Role</th>
                                <th class="text-left">Phone</th>
                                <th class="text-left">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(value2, i) in value.usersAddedByMPCandidate" :key="i">
                                <td>
                                  <span v-if="page == 1">
                                    {{ i + 1 }}
                                  </span>
                                  <span v-else>
                                    {{ i + 1 + 50 * (page - 1) }}
                                  </span>
                                </td>
                                <td>
                                  <span v-if="value2.firstname">{{ value2.firstname }} {{ value2.lastname }}</span>
                        <span v-else>-</span>
                                </td>
                                <td>
                                  <span v-if="value2.mainRole">{{ value2.mainRole.roles }}</span>
                        <span v-else>-</span>
                                </td>
                                <td> <span v-if="value2.phone">{{ value2.phone }}</span>
                        <span v-else>-</span></td>
                        <td>
                          <v-layout wrap>
                          <v-flex xs2>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog2 = true), (DeleteId2 = value2._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs2>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit2 = true), (editItem2 = value2)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                        </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-flex>
                      <v-flex xs12 v-else pa-4 class="title1">
                        No users found
                      </v-flex>
                        </v-layout>
                      </v-expansion-panel-content> -->
                      <!-- <v-layout>
            <v-flex xs12 px-4>
                <v-divider ></v-divider>
            </v-flex>
        </v-layout> -->
                    <!-- </v-expansion-panel>
                  </v-expansion-panels> -->
                </v-flex>
                <v-flex v-else xs12 align-self-center text-center pa-12>
                  No data found!
                </v-flex>
              </v-layout>


















          <!-- <v-layout wrap pa-4 v-if="constituencyList">
            <v-flex xs12 v-if="constituencyList.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont"><b>S.No.</b></th>
                      <th class="text-left tablefont"><b>Constituency</b></th>
                      <th class="text-left tablefont"><b>Actions</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in constituencyList" :key="i" class="table" >
                      <td>
                        <span v-if="page == 1">
                          {{ i + 1 }}
                        </span>
                        <span v-else>
                          {{ i + 1 + 50 * (page - 1) }}
                        </span>
                      </td>
                      <td>
                        <span  v-if="value.name">{{
                          value.name
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td class="text-left">
                         <v-layout wrap>
                          <v-flex xs1>
                              <v-icon
                            size="18"
                            title="View Panchayat"
                            style="cursor: pointer"
                            color="#182444"  @click="$router.push('/addPanchayat?id='+value._id)"
                            >mdi-eye</v-icon
                          >
                       </v-flex>
                          <v-flex xs1>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog = true), (DeleteId = value._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs1>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit = true), (editItem = value)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                        </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex xs12 v-else pa-4 text-center class="tablefont1"> No data found </v-flex>
          </v-layout> -->
        </v-card>
        <v-layout wrap v-if="constituencyList">
          <v-flex xs12 pt-4 v-if="constituencyList.length > 0">
            <v-pagination
              small
              color="#182444"
              v-model="page"
              :length="Pagelength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>
        <v-dialog width="400px" v-model="deletedialog">
            <v-card width="400px" class="pa-2">
             
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Delete</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                  @click="deletedialog = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-card-text class="pa-4"
                >Are you sure you want to delete this election type?
              </v-card-text>
              <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <!-- <v-btn
                  color="grey"
                  text
                  class="button1"
                  @click="deletedialog = false"
                  >Cancel</v-btn
                > -->
                <v-btn
                  color="#182444"
                  class="button1"
                  dark
                  @click="deleteConstituency(DeleteId)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog> 
      <!-------------------------ADD CUSTOMER TO SCHEME DIALOG----------------------------->
        <v-dialog width="500px" v-model="adddialog">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add Constituency</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(adddialog = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Constituency Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                        type="text"
                        label="Constituency"
                        v-model="newConstituency"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                   
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddConstituency()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
         <v-dialog width="800px" v-model="addUser">
          <v-form v-model="addcat2" ref="addcat2" @submit.prevent>
            <v-card tile width="800px" class="rounded-lg px-4">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center
                  ><span style="color: #182444" class="menuhead1"
                    >Add User</span
                  ></v-flex
                >
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addUser = false),(resetForm2())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-2>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> First Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="First Name"
                        v-model="firstname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Last Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="text"
                        label="Last Name"
                        v-model="lastname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="phone"
                        outlined
                        color="#50659f"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
             
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Role</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="rolesList"
                        v-model="mainRole"
                        label="Select Role"
                        item-text="roles"
                        item-value="_id" 
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#50659f"
                        v-model="gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddUser()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="500px" v-model="dialogedit">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="500px" class="px-4 py-4 rounded-lg">
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Constituency</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(dialogedit = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter election name"
                            v-model="editItem.name"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="editConstituency()"
                        ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="400px" v-model="deletedialog2">
            <v-card width="400px" class="pa-2">
             
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Delete</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                  @click="deletedialog2 = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-card-text class="pa-4"
                >Are you sure you want to delete this user?
              </v-card-text>
              <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn
                  color="#182444"
                  class="button1"
                  dark
                  @click="deleteUser(DeleteId2)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog width="800px" v-model="dialogedit2">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="800px" class="px-4 py-4 rounded-lg">
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit User</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="dialogedit2 = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> First Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="First Name"
                        v-model="editItem2.firstname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Last Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="text"
                        label="Last Name"
                        v-model="editItem2.lastname"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="editItem2.phone"
                        outlined
                        color="#50659f"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="editItem2.email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Role</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="rolesList"
                        v-model="editItem2.mainRole"
                        label="Select Role"
                        item-text="roles"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#50659f"
                        v-model="editItem2.gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap pa-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="editUser()"
                        ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      timeout: 2000,
      addcat2:false,
      deletedialog: false,
      DeleteId: null,
      deletedialog2: false,
      DeleteId2: null,
      addcat: false,
      editItem: {},
      editItem2: {},
      showSnackBar: false,
      ServerError: false,
      appLoading: false,
      constituencyList:[],
      newConstituency: null,
      genderList: ["Male", "Female", "Other"],
      page: 1,
      // page: 0,
      currentPage: 1,
      adddialog: false,
      dialogedit: false,
      dialogedit2:false,
      //   curItem: {},
      msg: null,
      addUser:false,
      firstname:"",
      lastname:"",
      phone:"",
      email:"",
      gender:"",
      mainRole:"",
      rolesList:[],
      userList:[],
      addId:"",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
    };
  },

  watch: {
   
   page() {
     this.getConstituency();
   },
  
 },
  mounted() {
    this.getConstituency();
    this.getRole();
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    resetForm() {
      this.$refs.addcat.reset();
    },
    deleteConstituency(id) {
      axios({
        url: "/constituency/delete",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.deletedialog = false;
            this.msg = response.data.msg;
            this.DeleteId = 0;
            this.appLoading = false;
            // this.getConstituency();
          location.reload();

          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    AddConstituency() {
      this.appLoading = true;
      axios({
        url: "/constituency/assembly/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.newConstituency,
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.adddialog = false;
          this.msg = response.data.msg;
          this.newConstituency = "";
          this.appLoading = false;
          // this.getConstituency();
          location.reload();

        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    editConstituency() {
      axios({
        url: "/constituency/assembly/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          name: this.editItem.name,
        },
      })
        .then((response) => {
          this.dialogedit = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          // this.getConstituency();
          location.reload();

        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getConstituency() {
      // console.log("role=",this.role)
      // this.appLoading = true;
      axios({
        url: "/constituency/assembly/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.constituencyList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    //user
    AddUser() {
      this.appLoading = true;
      axios({
        url: "/candidate/add/user",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          firstname : this.firstname,
          lastname : this.lastname,
          phone : this.phone,
          email : this.email,
          gender : this.gender,
          mainRole : this.mainRole,
          assignField : this.addId,
          level : "LoksabhaConstituency",
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.adddialog = false;
          this.msg = response.data.msg;
          this.firstname = "";
          this.lastname = "";
          this.phone = "";
          this.email = "";
          this.gender = "";
          this.addId = "";
          this.mainRole = "";
          this.addId = "";
          this.appLoading = false;
          this.addUser = false;
          // this.getUsera();
          location.reload();
      this.$refs.addcat2.reset();

        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getRole() {
      // console.log("role=",this.role)
      this.appLoading = true;
      axios({
        url: "/getalllist/user/roles",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          level : "LoksabhaConstituency",

        },
      })
        .then((response) => {
          this.appLoading = false;
          this.rolesList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    userValidate() {
      if (!this.firstname) {
        this.msg = "Please enter firstname";
        this.showsnackbar = true;
        return;
      }
      //  else if (!this.lastname) {
      //   this.msg = "Please enter lastname";
      //   this.showsnackbar = true;
      //   return;
      // }
      else if (!this.phone) {
        this.msg = "Please enter phone";
        this.showsnackbar = true;
        return;
      } else if (!this.email) {
        this.msg = "Please enter email";
        this.showsnackbar = true;
        return;
      } else if (!this.mainRole) {
        this.msg = "Please choose role";
        this.showsnackbar = true;
        return;
      } else if (!this.gender) {
        this.msg = "Please enter gender";
        this.showsnackbar = true;
        return;
      } 
       else {
        this.AddUser();
      }
    },
    getinnerData(id) {
      this.appLoading = true;
      axios({
        url: "/user/getlist",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params:{
          id:id,
          level:"LoksabhaConstituency",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.userList = response.data.data;
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    deleteUser(id) {
      axios({
        url: "/user/remove",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.deletedialog2 = false;
            this.msg = response.data.msg;
            this.DeleteId2 = "";
            this.appLoading = false;
            this.getinnerData(id);
          location.reload();

          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    editUser(){
      this.appLoading = true;
      axios({
        url: "/candidate/edit/user",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          // electionType: this.editItem2.userData.electionType._id,
          firstname : this.editItem2.firstname,
          lastname : this.editItem2.lastname,
          phone : this.editItem2.phone,
          email : this.editItem2.email,
          gender : this.editItem2.gender,
          mainRole : this.editItem2.mainRole._id,
          id:this.editItem2._id,
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.dialogedit2 = false;
          this.msg = response.data.msg;
          this.editItem2 = "";
          this.appLoading = false;
          // this.getConstituency();
          location.reload();

        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
.v-text-field input {
  font-family: kumbhBold;
}
</style>
  